

<template>
  <div class="periods" @click="removeAll()">
    <div class="breadcrumb text-no">
      <span class="TitBtn" @click="$router.go(-1)"
      ><i class="el-icon-arrow-left"></i> 返回</span
      >
      <span class="tipName"
      >账单 / 本期账单 /
        <span class="currentTip">{{ item.statBillNo }}</span></span
      >
    </div>
    <div class="cen df">
      <div
              class="leftTip"
              :class="
          item.settledStatus == 'un_completion' ? 'leftTipBackground-image' : ''
        "
      >
        <div v-if="item.settledStatus == 'completion'" class="text">
          账单金额 (元)
        </div>
        <div v-else class="text">待支付金额 (元)</div>
        <div
                class="closed-account-img"
                v-if="item.settledStatus == 'completion'"
        >
          <img
                  class="Open-according-to"
                  src="../../../assets/picture/closed-account.png"
                  alt=""
          />
        </div>
        <div
                class="num"
                :class="item.settledStatus == 'un_completion' ? 'bgc-blue' : 'color'"
        >
          <p style="font-size: 35px" v-html="sidebar.unRefundAmountNew1">
            {{ sidebar.unRefundAmountNew1 }}
          </p>
          <!-- <span>{{ sidebar.unRefundAmountNew1 }}</span>
          <span v-if="sidebar.unRefundAmountNew2"
            >.{{ sidebar.unRefundAmountNew2 }}</span
          >-->
        </div>
        <div class="line"></div>
        <div class="text">应收：</div>
        <div class="text2 text-hidden">{{ sidebar.totalAmount }}元</div>
        <div class="text">对账单号：</div>
        <div class="text2 text-hidden">{{ item.statBillNo }}</div>
        <div class="text">营业部：</div>
        <div class="text2 text-hidden" :title="item.actionOrgName">
          {{ item.actionOrgName }}
        </div>
        <div class="text">账期：</div>
        <div class="text2 text-hidden">
          {{ item.billStar }} 至 {{ item.billEnd }}
        </div>
        <div class="text">运单数：</div>
        <div class="text2 text-hidden">{{ sidebar.wayBillTotal }}</div>
        <div class="downloadBill text-no">
          <!-- <div class="confirm" v-if="item.settledStatus == 'un_completion'"> -->
          <!-- 确认账单 -->
          <el-popover
                  v-if="item.status == 'un_confirm'"
                  placement="bottom"
                  width="300"
                  trigger="click"
                  v-model="item.ConfirmTheBill"
          >
            <div>
              <h4 style="color: #000">确认账单提醒</h4>
              <div class="gray-word" style="margin: 10px 0">
                您是否要确认对账账单？确认后不可更改。
              </div>
              <div style="text-align: right; margin: 0">
                <el-button
                        size="small"
                        slot="reference"
                        @click="item.ConfirmTheBill = false"
                >暂不确认
                </el-button>
                <el-button
                        type="primary"
                        size="small"
                        slot="reference"
                        @click="confirmPay(item)"
                >确认对账单
                </el-button>
              </div>
            </div>
            <div class="confirm" slot="reference">确认账单</div>
          </el-popover>
          <div class="confirm colorrgb" v-else>已确认</div>
          <div class="gap"></div>
          <el-popover
                  placement="bottom"
                  trigger="click"
                  v-model="item.ToGetTheBill"
          >
            <div
                    class="pointer"
                    style="text-align: center; color: #000; line-height: 28px"
            >
              <div style="margin-bottom: 32px;" @click="ToGetTheBill(item, '下载账单')">下载账单</div>
              <div @click="ToGetTheBill(item, '发送邮箱')">发送邮箱</div>
            </div>
            <div class="download" slot="reference">
              获取账单<i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
        </div>
        <el-popover
                v-if="item.settledStatus == 'un_completion'"
                placement="bottom-start"
                width="500"
                trigger="click"
                v-model="item.confirmPayment"
        >
          <div>
            <h4 style="color: #000">确认账单，并支付<span style="color:red;margin-left: 30px;font-size: 12px;">温馨提示：请勿转账给个人！</span></h4>
            <div class="gray-word" style="margin: 10px 0">
              支付后，即默认您已确认账单无异常
            </div>
            <div class="df">
              <div class="money" style="line-height: 32px">
                支付金额：<span>￥</span>
              </div>
              <div style="width: 100px; margin: 0px 15px 0 5px">
                <el-input
                        size="small"
                        placeholder="0.00"
                        v-model="money"
                        @input="inputMoney"
                ></el-input>
              </div>
              <el-button
                      type="primary"
                      size="small"
                      slot="reference"
                      @click="singlePayment(item)"
              >确认支付
              </el-button>
              <el-button
                size="small"
                slot="reference"
                @click="showBankAccount(item.statBillNo)"
                >电汇转账
              </el-button>
              <el-button
                      size="small"
                      slot="reference"
                      @click="item.confirmPayment = false"
              >暂不支付
              </el-button>
            </div>
          </div>
          <div
                  class="pay text-no"
                  slot="reference"
          >
            <span  @click="pay(item.unRefundAmount)">支付账单</span>
            <h5 style="color:red; font-size:12px;">温馨提示：请勿转账给个人</h5>
          </div>
       
        </el-popover>
       
        <div class="NOpay text-no gray-word" v-else>已支付</div>
      </div>
      <!-- 中间内容 -->
      <div class="content">
        <!-- 选择器 & 按钮 头部筛选 -->
        <div class="title">
          <div class="df">
            <div class="flex1 mainTop">
              <div class="showcase" @click.stop="batchs()">
                <el-input
                        placeholder="搜索运单, 支持批量搜索"
                        v-model="waybillNumbers"
                        class="input-with-select"
                        size="mini"
                >
                </el-input>
              </div>
              <div class="batchInput" v-show="batchShow" @click.stop="">
                <el-input
                        ref="input"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        placeholder="请输入德邦运单号，最多支持10条数据查询，请使用英文逗号、空格键或回车键分隔！"
                        v-model="waybillNumbers"
                        @blur="fun()"
                >
                </el-input>
                <div class="batchSearch">
                  <el-button
                          @click.stop="searchs('搜索')"
                          size="small"
                          type="primary"
                          plain
                  >搜索</el-button
                  >
                </div>
              </div>
            </div>
            <div class="flex1 seldate">
              运单时间：
              <el-date-picker
                      v-model="timeQuantum"
                      type="daterange"
                      size="mini"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="btn df">
            <span class="b1" @click="EmptyFilter">清空筛选</span>
            <div class="b2" style="color: white" @click.stop="searchs('筛选')">筛选</div>
          </div>
        </div>
        <div class="main">
          <div class="tableTiele">
            <div class="setup" @click.stop="titShow">列表字段筛选</div>
            <div
                    class="titName"
                    v-show="tableShow"
                    @click.stop="tableShow = true"
            >
              <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
              >全选</el-checkbox
              >
              <!-- <div
                style="
                  margin: 5px 0;
                  width: 100%;
                  height: 1px;
                  background: #ccc;
                "
              ></div> -->
              <el-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                        v-for="city in cities"
                        :label="city"
                        :key="city"
                        :disabled="checkedCitiesDisable.includes(city)"
                >{{ city }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <div class="tables" style="max-height: 900px" :style="widths">
            <el-table :data="tableData" style="width: 100%" height="100%">
              <el-table-column fixed label="序号" align="center" width="48">
                <template slot-scope="scope">
                  <!-- 这里暂时写为 默认 index值, 需要后期与接口联动 , <当前页> 和 <x条/页> -->
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                      fixed
                      prop="date"
                      label="运单号"
                      width="189"
                      v-if="checkedCities.includes('运单号')"
              >
                <template slot-scope="scope">
                  <span class="bgc-blue">{{ scope.row.sourceBillNo }}</span>
                </template>
              </el-table-column>
              <el-table-column
                      prop="businessDate"
                      width="100"
                      label="业务日期"
                      v-if="checkedCities.includes('业务日期')"
              >
              </el-table-column>
              <el-table-column
                      prop="productType"
                      label="产品类型"
                      width="100"
                      v-if="checkedCities.includes('产品类型')"
              >
                <template slot-scope="scope">
                  <span
                          class="text-hidden pointer"
                          :title="scope.row.productType"
                  >{{ scope.row.productType }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                      prop="deliveryStation"
                      label="始发站"
                      width="100"
                      v-if="checkedCities.includes('始发站')"
              >
                <template slot-scope="scope">
                  <span
                          :title="scope.row.deliveryStation"
                          class="text-hidden pointer"
                  >{{ scope.row.deliveryStation }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                      prop="destination"
                      label="目的地"
                      width="200"
                      v-if="checkedCities.includes('目的地')"
              >
                <template slot-scope="scope">
                  <span
                          class="text-hidden pointer"
                          :title="scope.row.destination"
                  >{{ scope.row.destination }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                      prop="deliveryCustomerName"
                      label="发货人"
                      width="100"
                      v-if="checkedCities.includes('发货人')"
              >
                <template slot-scope="scope">
                  <span
                          class="text-hidden pointer"
                          :title="scope.row.deliveryCustomerName"
                  >{{ scope.row.deliveryCustomerName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                      prop="consignee"
                      label="收货人"
                      width="100"
                      v-if="checkedCities.includes('收货人')"
              >
                <template slot-scope="scope">
                  <span
                          class="text-hidden pointer"
                          :title="scope.row.consignee"
                  >{{ scope.row.consignee }}</span
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="goodsName"
                label="货物名称"
                width="100"
                v-if="checkedCities.includes('货物名称')"
              >
              </el-table-column> -->
              <el-table-column
                      prop="pickupWay"
                      label="提货方式"
                      width="100"
                      v-if="checkedCities.includes('提货方式')"
              >
              </el-table-column>
              <el-table-column
                      prop="packageQuantity"
                      label="件数"
                      width="100"
                      v-if="checkedCities.includes('件数')"
              >
              </el-table-column>
              <el-table-column
                      prop="weight"
                      label="重量"
                      width="100"
                      v-if="checkedCities.includes('重量')"
              >
              </el-table-column>
              <el-table-column
                      prop="volume"
                      label="体积"
                      width="100"
                      v-if="checkedCities.includes('体积')"
              >
              </el-table-column>
              <el-table-column
                      prop="chargeWeight"
                      label="计费重量"
                      width="100"
                      v-if="checkedCities.includes('计费重量')"
              >
              </el-table-column>
              <el-table-column
                      prop="publishFreinghtTax"
                      label="公布价运费"
                      width="100"
                      v-if="checkedCities.includes('公布价运费')"
              >
              </el-table-column>
              <el-table-column
                      prop="insuranceStatement"
                      label="保价"
                      width="100"
                      v-if="checkedCities.includes('保价')"
              >
              </el-table-column>
              <el-table-column
                      prop=" insuranceFee"
                      label="保价费"
                      width="100"
                      v-if="checkedCities.includes('保价费')"
              >
              </el-table-column>
              <el-table-column
                      prop="packingFee"
                      label="包装费"
                      width="100"
                      v-if="checkedCities.includes('包装费')"
              >
              </el-table-column>
              <el-table-column
                      prop="resendFee"
                      label="中转费"
                      width="100"
                      v-if="checkedCities.includes('中转费')"
              >
              </el-table-column>
              <el-table-column
                      prop="codAmount"
                      label="代收货款金额"
                      width="120"
                      v-if="checkedCities.includes('代收货款金额')"
              >
              </el-table-column>
              <el-table-column
                      prop="collectionChargesPoundage"
                      label="代收货款手续费"
                      width="120"
                      v-if="checkedCities.includes('代收货款手续费')"
              >
              </el-table-column>
              <el-table-column
                      prop="amount"
                      label="总金额"
                      width="100"
                      v-if="checkedCities.includes('总金额')"
              >
              </el-table-column>
              <el-table-column
                      prop="unverifyAmount"
                      label="未核销金额"
                      width="200"
                      v-if="checkedCities.includes('未核销金额')"
              >
              </el-table-column>
              <el-table-column fixed="right" label="操作"  align="center"  width="164"  prop="amount">
                <template slot-scope="scope">
                  <div class="df" style="justify-content:center;">
                    <el-button v-if="item.settledStatus == 'un_completion'"
                            @click="selectBy(scope.row )"
                            type="text"
                            size="small"
                    >{{ scope.row.billDiffStatus }}</el-button>
                    <!-- unresolved 未处理
           
unmark 未标记   标 记
resolved 已办结 -->
                    <el-button v-else-if="item.settledStatus=='completion' && scope.row.billDiffStatus != ' 标 记 ' "
                            @click="selectBy(scope.row )"
                            type="text"
                            size="small"
                    >{{ scope.row.billDiffStatus }}</el-button>
                    <div v-if="scope.row.orderSubType == 'OR' || scope.row.orderSubType == 'PFCR' || scope.row.orderSubType == 'DR'" class="cut-off-rule"></div>
                    <el-button v-if="scope.row.orderSubType == 'OR' || scope.row.orderSubType == 'PFCR' || scope.row.orderSubType == 'DR'" type="text" size="small" @click="TheWaybillDetails(scope.row.sourceBillNo), drawer = true">运单详情</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bottom" v-if="isBottom && totalNumber > 10">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currpage"
                    :page-sizes="[10, 20, 50]"
                    :page-size="pagesize"
                    layout="total,prev, pager, next, sizes,jumper"
                    :total="totalNumber"
            >
              <!-- sidebar.wayBillTotal -->
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载账单弹框 -->
    <el-dialog
            class="fl"
            title="请选择下载账单格式"
            :visible.sync="NewDialogBox1"
            width="34%"
            top="236px"
    >
      <div class="strong-frame">
        <div class="row">
          <div
                  :class="DownloadTheformat == 'excel' ? 'divpitch-on' : ''"
                  @click="DownloadTheformat = 'excel'"
          >
            <img class="excel" src="../../../assets/picture/excel.png" alt="" />
          </div>
          <div
                  :class="DownloadTheformat == 'pdf' ? 'divpitch-on' : ''"
                  @click="DownloadTheformat = 'pdf'"
          >
            <img class="pdf" src="../../../assets/picture/pdf.png" alt="" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox1 = false" size="small">取 消</el-button>
        <el-button
                @click="download"
                type="primary"
                size="small"
                :loading="downloadLoading"
        >下载</el-button
        >
      </span>
    </el-dialog>
    <!-- 账单发送邮箱 -->
    <el-dialog
            class="fl"
            title="发送邮箱"
            :visible.sync="NewDialogBox2"
            width="34%"
            top="236px"
    >
      <div
        v-for="(emailItem, index) in emailList"
        :key="index"
      >
        <div class="strong-frame top df">
          <span style="width: 80px; line-height: 32px">邮箱{{ index + 1 }}：</span>
          <el-input
            v-model="emailItem.value"
            :placeholder="`请输入邮箱${index + 1}`"
            size="small"
          ></el-input>
          <i
            v-if="index > 0"
            class="el-icon-delete"
            style="margin-left: 8px; line-height: 32px; cursor: pointer; color: #f56c6c;"
            @click="emailList.splice(index, 1)"
          ></i>
        </div>
        <div
          v-if="emailItem.error"
          style="color: #f56c6c; font-size: 12px; padding-left: 80px; margin-top: 4px"
        >邮箱格式不正确</div>
      </div>
      <div style="margin-top: 8px">
        <el-button
          v-if="emailList.length < 3"
          type="text"
          icon="el-icon-plus"
          size="small"
          @click="addEmail"
        >新增邮箱</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox2 = false" size="small">取 消</el-button>
        <el-button @click="SendEmail" type="primary" size="small"
        >发 送</el-button
        >
      </span>
    </el-dialog>
    <!-- 运单详情抽屉 640-->
    <el-drawer
            :visible.sync="drawer"
            :with-header="false"
            :page-sizes="[5, 16, 32]"
            :page-size="pagesize"
            :wrapperClosable="false"
    >
      <div class="The-waybill-details">
        <div class="The-waybill-details-title text-no">
          <div class="flex1">
            <div
                    class="tabs"
                    :class="tab == 1 ? 'tabBorder' : ''"
                    @click="cutover(1)"
            >
              运单详情
            </div>
            <div
                    class="tabs"
                    :class="tab == 2 ? 'tabBorder' : ''"
                    @click="cutover(2)"
            >
              运单轨迹
            </div>
          </div>
          <i class="close el-icon-close" @click="drawer = false"></i>
        </div>
        <div class="">
          <div v-if="tab == 1" class="details-box">
            <div class="details-box-t df">
              <div class="waybill-number text-hidden2">{{waybillNumber}}</div>
              <!-- <div class="waybill-type-box">
                <div class="waybill-type">子母件</div>
              </div> -->
              <div class="top11">
                <div>目的地：</div>
                <div>{{waybillDetails.receiveCityName}}</div>
              </div>
              <div class="top11">
                <!-- <div>订单号：WX2018338533023</div> -->
                <div>开单时间：{{waybillDetails.createWaybillTime?$moment(+waybillDetails.createWaybillTime).format("YYYY-MM-DD HH:mm"):''}}</div>
              </div>
            </div>
            <div class="details-box-address">
              <div class="df ">
                <div>
                  <img src="../../../assets/picture/sender.png" style="width: 40px;" alt="">
                </div>
                <div>
                  <div>
                    <span>{{waybillDetails.shipperCustomerContact}}</span>
                    <span style="padding-left: 8px;">{{waybillDetails.shipperCustomerMobile}}</span>
                  </div>
                  <div class="details-address">{{(waybillDetails.shipperProvinceName|| '')+''+(waybillDetails.shipperCityName|| '')+''+(waybillDetails.shipperDistrictName|| '')+''+(waybillDetails.shipperTownshipName|| '')+''+(waybillDetails.shipperStreetCode|| '')+''+(waybillDetails.shipperContactAddress|| '')}}</div>
                </div>
              </div>
              <div class="df" style="padding-top: 11px;">
                <div >
                  <img src="../../../assets/picture/recipients.png" style="width: 40px;" alt="">
                </div>
                <div>
                  <div>
                    <span>{{waybillDetails.receiveCustomerContact}}</span>
                    <span style="padding-left: 8px;">{{waybillDetails.receiveCustomerMobile}}</span>
                  </div>
                  <div class="details-address">{{(waybillDetails.receiveProvinceName || '')+''+(waybillDetails.receiveCityName|| '')+''+(waybillDetails.receiveDistrictName|| '')+''+(waybillDetails.receiveTownshipName|| '')+''+(waybillDetails.receiveStreetName|| '')+''+(waybillDetails.receiveAddress|| '')}}</div>
                </div>
              </div>
            </div>
            <div class="cargo-information-box">
              <div class="df cargo-information">
                <div>货物信息：{{waybillDetails.goodsName}}</div>
                <div class="cargo-information2">货物件数：{{waybillDetails.goodsTotalQuantity}}</div>
                <div>计费方式：{{waybillDetails.chargingType}}</div>
              </div>
              <div class="df cargo-information">
                <div>货物重量：{{waybillDetails.totalGoodsWeight}}kg</div>
                <div class="cargo-information2">计费重量：{{waybillDetails.chargedWeight}}kg</div>
                <div>代收货款：{{waybillDetails.codAmount || 0}}元</div>
              </div>
              <div class="df cargo-information">
                <div>付款方式：{{waybillDetails.paymentMethodName}}</div>
                <div class="cargo-information2">货物体积：{{(waybillDetails.totalGoodsVolume || '') +'m³'}}</div>
                <div>保价金额：{{waybillDetails.insuranceFee || 0}}元</div>
              </div>
              <div class="df cargo-information">
                <div>提货方式：{{waybillDetails.receiveMethod}}</div>
                <div class="cargo-information2">费用合计：{{waybillDetails.totalFee}}元</div>
                <div>公布价运费：{{waybillDetails.releasePriceFee}}元</div>
              </div>
              <div class="df cargo-information">
                <div>签收单返还：{{waybillDetails.returnReceiptType}}</div>
                <!-- <div>优惠费用合计：-asdasdsa4元</div> -->
                <div class="cargo-information2">保价服务费：{{waybillDetails.insuranceFee}}元</div>
                <div>附加费用：{{waybillDetails.additiveFee || 0}}元</div>
              </div>
              <!-- <div class="df cargo-information">
                <div>签收单返还：{{waybillDetails.returnReceiptType}}</div>
                <div class="cargo-information2"></div>
              </div> -->
            </div>
            <!-- <div class="df function-box fr">
              <div class="function-btn df">
                <img  src="../../../assets/picture/down.png" alt="">
                <div>下载</div>
              </div>
              <div class="function-btn df">
                <img  src="../../../assets/picture/printer.png" alt="">
                <div>打印</div>
              </div>
            </div> -->
          </div>
          <div v-if="tab == 2" class="locus-box">
            <!-- <div> -->
            <div class="track-series">
              <div class="track" v-for="(v,k) in trackInfo" :key="k">
                <!-- <div  class="express-state fr">已签收</div>  -->
                <div v-if="v.eventType == 'ALREADY_SIGN'" class="express-state fr">已签收</div>
                <div v-else-if="v.eventType == 'SENT_SCAN'" class="express-state fr">派送中</div>
                <div v-else-if="v.eventType == 'HAS_BILLING'" class="express-state fr">揽收中</div>
                <div v-else class="express-state fr">运输中</div>
                <div class="circle">
                  <div class="center"></div>
                  <span v-if=" k != 0 && k != trackInfo.length-1 "></span>
                  <div v-if=" k == 0 " class="first"></div>
                  <div v-if=" k == trackInfo.length-1 " class="first"></div>
                </div>
                <div class="detail ">
                  <div class="df">
                    <div style="padding-bottom: 8px;" >{{v.operateTime?$moment(v.operateTime).format("YYYY年MM月DD日 HH:mm"):''}}</div>
                  </div>
                  <!-- <div>{{v.trackInfo}}</div> -->
                  <div v-if="v.eventType == 'SENT_SCAN'">
                    <span >{{v.trackInfo}}</span>
                    <span >派件员：{{v.operatorName}}，电话：</span>
                    <span style="color: #fcb01c;">{{v.operatorPhone}}</span>
                  </div>
                  <div v-else>{{v.trackInfo}}</div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </el-drawer>




    <!--查看差异-->
    <el-dialog id="selectDiffer"  :title="differTitle"  :visible.sync="selectDiffer"  @close="closeDialogAddgsVisible()" width="540px" >
      <div  style="display: flex;flex-direction: row">
        <ul id="selectNumList">
          <li :key="item.differTitle" v-for="item in selectAllMessages" >
            <span class="differTitle">{{item.differTitle}}</span>
            <el-popover trigger="hover" v-if="item.color===1" placement="right" >
              <span>{{phoneNum}}</span>
              <span :class="item.color===1?'blue':'black'" slot="reference" class="differValue">{{item.value}}</span>
            </el-popover>
            <span v-else :class="item.color===1?'blue':'black'" slot="reference" class="differValue">{{item.value}}</span>
          </li>
       </ul>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button el-button--primary type="primary"  @click="selectDiffer = false">返 回</el-button>
      </div>
    </el-dialog>
    <!--增删改差异-->
    <el-dialog id="operateDiffer"  :title="differTitle"  :visible.sync="showDiffer"  @close="closeDialogAddgsVisible()" width="540px" >
      <div  v-for="item1 in allMessages" :key="item1.diffBillNo" style="display: flex;flex-direction: row">
        <ul  id="numList">
          <li v-if="adapt"><span class="differTitle">差异单号:</span><span  v-if="adapt" style="width: 60%;text-align: left" class="differValue">{{item1.diffBillNo}}</span>
            <span style="width: 85px;color: #008cff" v-if="!pullDown"  @click="setPullDown(true)">显示▼</span>
            <span style="width: 85px;color: #008cff"  v-else @click="setPullDown(false)">收起▲ </span>
          </li>
          <li v-else> </li>
          <li v-if="pullDown" ><span class="differTitle">对账单号:</span><span class="differValue">{{item1.statBillNo}}</span></li>
          <li v-if="pullDown" ><span class="differTitle">运单号:</span><span class="differValue">{{item1.sourceBillNo}}</span></li>
          <li  v-if="pullDown"><span v-if="adapt" class="differTitle">上报人:</span><span v-if="adapt" class="differValue">{{item1.createUserName}}</span></li>
        </ul>
      </div>
      <el-form   >
        <el-form-item label="差异类型:" >
          <el-select  placeholder="请选择"  v-model="listOptionId" @change="selectOption()">
            <el-option  v-for="item in optionList" :key="item.listName" :label="item.listName" :value="item.listValue"/>{{item.listName}}
          </el-select>
        </el-form-item>
        <el-form-item  label="差异说明:" >
          <el-input   maxlength="50" v-model="msg.content" @keyup.native="detectContentup()"  resize="none" @keydown.native="detectContent()"  :autosize="{minRows:4,maxRows:4}" type="textarea"  placeholder="请输入实际货物信息或其他补充信息" style="width: 80%;"/><!-- v-text="form.originalDesc"    autosize   :autosize="{ minRows: 2, maxRows: 4}" -->
          <p v-if="remainText"  style="margin-left: 90px;text-align: left;color: red">请输入差异原因</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer " :id="displayStyle===1?'addDisplay':'delDisplay'">
        <template v-if="adapt">
          <el-popover width="320" height="122"  v-model="visible_differ">
            <div style="    padding: 10px;">
              <p style="    margin-bottom: 20px;">删除标记运单，在账单确认前都可再次标记</p>
              <div style="display: flex;justify-content:flex-end">
                <el-button   slot="reference" @click="visible_differ=false">暂不删除</el-button>
                <el-button type="primary"  @click="delDiffer"  slot="reference">确认删除</el-button>
              </div>

            </div>
            <el-button id="isDel" slot="reference">删除</el-button>
          </el-popover>

        </template>
        <div>
          <el-button @click="showDiffer = false" style="margin-right: 12px">取 消</el-button>

          <el-popover width="320" height="122"  v-model="visible_differ1"  v-if="adapt">
            <div style=" padding: 10px;">
              <p style=" margin-bottom: 20px;">是否确认修改</p>
              <div style="display: flex;justify-content:flex-end">
                <el-button   slot="reference" @click="visible_differ1=false">取消</el-button>
                <el-button type="primary"  @click="saveDiffer()"   slot="reference">确认</el-button>
              </div>
            </div>
            <el-button  slot="reference"   type="primary"  >{{differButton}}</el-button>
          </el-popover>
          <el-button v-else slot="reference"   type="primary" @click="saveDiffer()"  >{{differButton}}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 银行账号复制 -->
    <el-dialog
      title="电汇账号信息"
      :visible.sync="isShowAccountDialog"
      width="450px">
      <div class="e_account">
        <div><label for="">开户名：</label>{{formAccount.compBankAccountName}}</div>
        <div><label for="">开户行：</label>{{formAccount.compBankName}}</div>
        <div><label for="">开户账号：</label>{{formAccount.compBank}}</div>
        <h5 style="margin-top:8px;color:red; font-size:12px;">温馨提示：请勿转账给个人！</h5>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowAccountDialog = false" size="small">关 闭</el-button>
        <el-button type="primary" @click="copyAccountInfo" size="small">一键复制</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import API from "../../../api/bill";
  import axios from "axios";
  import { paths } from "../../../utils/pathNew.js";
  // import {strFil2} from '../../../utils/str'
  const api = new API();
  const cityOptions = [
    "公布价运费",
    "保价",
    "保价费",
    "包装费",
    "中转费",
    "代收货款金额",
    "代收货款手续费",
    "序号",
    "业务日期",
    "运单号",
    "产品类型",
    "始发站",
    "目的地",
    "发货人",
    "收货人",
    "货物名称",
    "提货方式",
    "件数",
    "重量",
    "体积",
    "计费重量",
    "总金额",
    "未核销金额",
  ]; // 这里是表头展示的字段  ==>要与表格对应
  export default {
    data() {
      return {
        waybillNumber:'',
        waybillDetails:{},
        trackInfo:[],

        optionList:[
          {listName:"非我司运单",listValue:"not_my_waybill"},
          {listName:"运费有误",listValue:"freight"},
          {listName:"产品类型有误",listValue:"product_type"},
          {listName:"重量体积有误",listValue:"weight_volume"},
          {listName:"保价有误",listValue:"valuation"},
          {listName:"价格折扣有误",listValue:"price_discount"},
          {listName:"此单已付款",listValue:"has_paid"},
          {listName:"其他问题",listValue:"other"}
        ],



        allMessages:[//拿接口是拿sourceBillNo这个字段
          {diffBillNo:"",statBillNo:"",sourceBillNo:"",createUserName:""},
        ],

        selectAllMessages:[
          {differTitle:"差异单号:",value:"",color:""},
          {differTitle:"对账单号:",value:"",color:""},
          {differTitle:"运单号:",value:"",color:""},
          {differTitle:"上报人:",value:"",color:""},
          {differTitle:"差异类型:",value:"",color:""},
          {differTitle:"差异说明:",value:"",color:""},
          {differTitle:"办结人:",value:"",color:1},
          {differTitle:"处理意见:",value:"",color:""}
        ],
        phoneNum:"",
        delMessage:"",
        addMessage:"",
        sourceBillNo:'',//暂存,
        orderNo:'',//暂存订单号
        statBillNo:'',
        differButton:'',
        visible_differ:false,
        visible_differ1:false,
        cancelConfirmMessage:'',
        sureConfirmMessage:'',
        listOptionId:"",
        remainText:false,//提示输入差异原因
        displayStyle:1,//1新增 2修改删除 3查看完结
        adapt:false,//区分新增和修改
        addNew:true,
        typeId:"success",
        typeTitle:"标记成功",
        differTitle:"差异标记",
        selectDiffer:false,//显示隐藏完结差异框
        showDiffer:false,//显示新增或修改框
        pullDown: false,
        tab: 1,
        drawer: false,
        downloadLoading: false,
        emailList: [{ value: "", error: false }],
        mailbox: "",
        gitBill: "",
        DownloadTheformat: "excel",
        NewDialogBox1: false,
        NewDialogBox2: false,
        money: 0,
        filtrate: false,
        totalNumber: 0, //分页总条数
        isBottom: false,
        parme: {},
        item: {},
        detail:"",
        timeQuantum: "", // 运单时间
        checkAll: false, // 全选默认值
        msg:{content:""},
        checkedCities: [
          "序号",
          "业务日期",
          "运单号",
          "产品类型",
          "始发站",
          "目的地",
          "发货人",
          "收货人",
          "货物名称",
          "提货方式",
          "件数",
          "重量",
          "体积",
          "计费重量",
          "总金额",
          "未核销金额",
        ], // 勾选项 遍历勾选框   //==>默认禁用项, 填写禁用项
        cities: cityOptions,
        isIndeterminate: true,
        tableShow: false,
        batchShow: false,
        // waybillNumber: "", // 运单 搜素
        waybillNumbers: "", // 批量搜索 ===
        // strNew:'', //去除空格 和换行 的 运单号
        sidebar: {}, //侧边栏数据
        //  表格 数据 list
        tableData: [],
        pagesize: 10,
        currpage: 1, // 当前第几页
        screenWidth: document.body.clientWidth, // 监听 屏幕的宽度
        isShowAccountDialog:false,
        formAccount:{}
      };
    },
    computed: {
      //  宽度样式:计算可视区宽度 返回表格的 宽度样式 // ====>(可视区变换表格宽度没继承 flex:1 的宽度)BUG 的优化 (++ 如果有更好的解决方法, 可以重写 ++)
      widths() {
        return { width: this.screenWidth - 300 + "px" };
      },
    },
    watch: {},
    methods: {
      // 运单详情按钮
      TheWaybillDetails(waybillNumber){
        this.cutover(1)
        this.waybillNumber = waybillNumber
        this.getInfoByWaybillNoRequest({sourceBillNo:waybillNumber})
        this.queryWaybillTrackRequest(waybillNumber)
      },
      // 运单轨迹接口
      async queryWaybillTrackRequest(waybillNumber){
        console.log(waybillNumber);
        let res = await api.queryWaybillTrack({sourceBillNo:waybillNumber})
        this.trackInfo = res.waybillTracks
      },
      // 运单详情接口
      async getInfoByWaybillNoRequest(waybillNumber){
        console.log(waybillNumber);
        let res = await api.getInfoByWaybillNo(waybillNumber)
        this.waybillDetails = res
      },
      // 运单详情头部样式
      cutover(i) {
        if (i == this.tab) return;
        this.tab = i;
      },
      // 输入金额判断
      inputMoney() {
        if (this.money - 0 > 100000000) {
          this.$message.error("发票金额不能大于一亿元，请重新输入");
          this.money = this.sidebar.totalUnVerifyAmount;
        }
      },
      // 获取邮箱
      async getCustomerEmail() {
        let res = await api.getCustomerEmail();
        if (res) {
          this.emailList = [{ value: res[0] || "", error: false }];
          this.mailbox = res[0] || "";
        }
      },
      // 新增邮箱输入行
      addEmail() {
        if (this.emailList.length < 3) {
          this.emailList.push({ value: "", error: false });
        }
      },
      // 发送邮箱
      SendEmail() {
        var reg =
                /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        let hasError = false;
        const validEmails = [];
        this.emailList.forEach((emailItem) => {
          const email = (emailItem.value || "").trim();
          if (email) {
            if (reg.test(email)) {
              emailItem.error = false;
              validEmails.push(email);
            } else {
              emailItem.error = true;
              hasError = true;
            }
          } else {
            emailItem.error = false;
          }
        });
        if (hasError || validEmails.length === 0) {
          return;
        }
        this.mailbox = validEmails.join(",");
        this.$emit("acquireEmail", this.mailbox);
        this.sendEmailExcel();
      },
      async sendEmailExcel() {
        let parme = {
          statBillNo: this.gitBill,
          email: this.mailbox,
        };
        let res = await api.sendEmailExcel(parme);
        if (res) {
          if (res == "发送成功！") {
            this.NewDialogBox2 = false;
            console.log(res);
            this.$message({
              message: res,
              type: "success",
            });
          }
        } else {
          console.log(res);
        }
      },
      // 下载
      download() {
        console.log("下载");
        this.downloadLoading = true;
        window.setTimeout(() => {
          this.downloadLoading = false;
        }, 7000);
        api
                .startDownload({
                  statBillNo: this.gitBill,
                  downLoadType: this.DownloadTheformat,
                })
                .then((resp) => {
                  let downloadKey = resp;
                  console.info(downloadKey);
                  window.sessionStorage.setItem("downloadKey", downloadKey);
                  this.timeId = window.setTimeout(() => {
                    this.tryDownLoad();
                  }, 1000);
                });
      },
      tryDownLoad() {
        let downloadKey = window.sessionStorage.getItem("downloadKey");
        let preParam = {
          statBillNo: this.gitBill,
          downLoadType: this.DownloadTheformat,
          downloadStatus: "query",
          downloadKey: downloadKey,
        };
        axios
                .post("statements/downloadFile", preParam)
                .then((res) => {
                  if ("success" == res.data) {
                    this.downloadFinal();
                  } else {
                    // this.tryDownLoad()
                  }
                  if ("downloading" == res.data) {
                    window.setTimeout(() => {
                      this.tryDownLoad();
                    }, 2000);
                  }
                })
                .catch(function (error) {
                  console.info(error);
                });
      },
      async downloadFinal() {
        // let list_name = "账单";
        let downloadKey = window.sessionStorage.getItem("downloadKey");
        let param = {
          statBillNo: this.gitBill,
          downLoadType: this.DownloadTheformat,
          downloadStatus: "download",
          downloadKey: downloadKey,
        };
        let res = await api.downloadFile2(param);
        this.downloadLoading = false;
        this.NewDialogBox1 = false;
        this.$message({
          message: "下载成功",
          type: "success",
        });
        // debugger
        let link = document.createElement("a");
        //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
        let blogw = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
        link.href = objectUrl;
        link.download = decodeURI(
                escape(
                        res.headers["content-disposition"].replace("attachment;filename=", "")
                )
        ); //  下载的时候的文件名
        link.click();
        window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
        window.clearInterval(this.timeId);
        this.timeId = null;
      },
      // 获取账单
      ToGetTheBill(item, distinction) {
        // this.NotPayingBills[key].ToGetTheBill = false
        this.gitBill = item.statBillNo;
        console.log(this.gitBill);
        if (distinction == "下载账单") {
          console.log("下载账单");
          this.NewDialogBox1 = true;
        } else {
          this.EmailError = false;
          this.NewDialogBox2 = true;
          this.getCustomerEmail();
          console.log("发送邮箱");
        }
      },
      // 详情请求
      async detailsRequest() {
        this.isBottom = true;
        let parme = {
          statBillNo: this.item.statBillNo,
          currentPage: this.currpage,
          pageSize: this.pagesize,
        };
        let res = await api.queryTradeDetailByStatNo(parme);
        this.sidebar = res;
        this.totalNumber = this.sidebar.wayBillTotal;
        this.sidebar.unRefundAmountNew1 = this.separateNum(
                this.sidebar.totalUnVerifyAmount.toString()
        );
        /*   this.sidebar.unRefundAmountNew1 = (
          "" + this.sidebar.totalUnVerifyAmount
        ).split(".")[0];
        this.sidebar.unRefundAmountNew2 = (
          "" + this.sidebar.totalUnVerifyAmount
        ).split(".")[1];*/
        this.tableData = res.dataList;
        this.tableData.forEach((item) => {
          if(item.billDiffStatus=="unmark"){
            item.billDiffStatus=" 标 记 ";
          }else if(item.billDiffStatus=="unresolved"){
            item.billDiffStatus="已标记";
          }else{
            item.billDiffStatus="已完结";
          }
          item.businessDate = this.$moment(item.businessDate).format(
                  "YYYY-MM-DD"
          );
        });

      },
      separateNum(value) {
        if (!value) return "0.00";
        var intPart = Number(value).toFixed(0); //获取整数部分
        var intPartFormat = intPart
                .toString()
                .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
        var floatPart = ".00"; //预定义小数部分
        var value2Array = value.split(".");
        //=2表示数据有小数位
        var totalMoney;
        if (value2Array.length == 2) {//说明有小数
          floatPart = value2Array[1].toString(); //拿到小数部分
          if (floatPart.length == 1) {//只有一位小数，补0
            totalMoney = intPartFormat + "." + floatPart + "0";
            totalMoney = totalMoney.split(".");
            return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
          } else {
            totalMoney = intPartFormat + "." + floatPart;
            totalMoney = totalMoney.split(".");
            return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
          }
        } else {
          totalMoney = intPartFormat + floatPart;
          totalMoney = totalMoney.split(".");
          return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
        }
      },
      async detailsRequestSearch(distinguish) {
        let parme = {};
        if (distinguish == "筛选") {
          this.isBottom = true;
          if (this.timeQuantum !== "") {
            this.filtrate = true;
            this.timeQuantum[0] = this.$moment(this.timeQuantum[0]).format(
                    "YYYY-MM-DD"
            );
            this.timeQuantum[1] = this.$moment(this.timeQuantum[1]).format(
                    "YYYY-MM-DD"
            );
            parme = {
              statBillNo: this.item.statBillNo,
              businessDateStart: this.timeQuantum[0],
              businessDateEnd: this.timeQuantum[1],
              sourceBillNo: this.waybillNumbers,
              currentPage: this.currpage,
              pageSize: this.pagesize,
            };
          } else {
            console.log("没有有时间");
            this.isBottom = false;
            parme = {
              statBillNo: this.item.statBillNo,
              sourceBillNo: this.waybillNumbers,
              currentPage: 1,
              pageSize: 10,
            };
          }
        } else {
          console.log("搜索");
          this.isBottom = false;
          parme = {
            statBillNo: this.item.statBillNo,
            sourceBillNo: this.waybillNumbers,
            currentPage: 1,
            pageSize: 10,
          };
        }
        let res = await api.queryTradeDetailByStatNo(parme);
        this.tableData = res.dataList;
        this.totalNumber = res.wayBillTotal;
        this.tableData.forEach((item) => {
          if(item.billDiffStatus=="unmark"){
            item.billDiffStatus=" 标 记 ";
          }else if(item.billDiffStatus=="unresolved"){
            item.billDiffStatus="已标记";
          }else{
            item.billDiffStatus="已完结";
          }
          item.businessDate = this.$moment(item.businessDate).format(
                  "YYYY-MM-DD"
          );
        });
      },
      // 点击空白 清除所有无关弹框
      removeAll() {
        this.batchShow = false; // 点击空白 隐藏批量配置
        this.tableShow = false; // 点击空白 隐藏配置表头
      },
      batchs() {
        var tiems = "";
        tiems = setTimeout(() => {
          this.batchShow = true;
          clearTimeout(tiems);
        }, 100);
        // 使 输入框 获取焦点
        var tiems2 = "";
        tiems2 = setTimeout(() => {
          this.$refs.input.focus();
          clearTimeout(tiems2);
        }, 200);
      },
      strFil2(list, type) {
        let a = [];
        list.map((i) => {
          i.split(type).map((j) => {
            if (j) {
              a.push(j);
            }
          });
        });
        return a;
      },
      // 清空筛选
      EmptyFilter() {
        this.waybillNumbers = "";
        this.timeQuantum = "";
        this.searchs('筛选');
        // this.waybillNumbers = ''
      },
      //批量搜索框失去焦点
      fun() {
        var temporary = this.waybillNumbers.split("\n");
        this.waybillNumbers = this.strFil2(
                this.strFil2(this.strFil2(temporary, "，"), " "),
                ","
        ).join();
      },
      // 搜索
      searchs(distinguish) {
        this.batchShow = false;
        var temporary = this.waybillNumbers.split("\n");
        // temporary = this.waybillNumbers.split("\t");
        this.waybillNumbers = this.strFil2(
                this.strFil2(this.strFil2(temporary, "，"), " "),
                ","
        ).join();
        let strNewlist = this.strFil2(
                this.strFil2(this.strFil2(temporary, "，"), " "),
                ","
        );
        if (strNewlist.length > 10) {
          return this.$message.error(
                  "只支持10条以内运单查询，请确认您输入的数据！"
          );
        }
        if (distinguish == "搜索" && this.waybillNumbers == "") {
          return this.$message.error("搜索不能为空！");
        }
        if (
                (this.waybillNumbers == "" && this.timeQuantum == "") ||
                this.timeQuantum == null
        ) {
          return this.detailsRequest();
        }
        this.currpage = 1;
        this.pagesize = 10;
        //  this.waybillNumber = strNewlist[0]+'等'+strNewlist.length+'条数据'
        this.detailsRequestSearch(distinguish);
      },
      // 分页 : 选择展示条数
      handleSizeChange(val) {
        this.pagesize = val;
        this.currpage = 1; // 切换 没有多少条的时候 重置为第1页开始
        this.filtrate ? this.detailsRequestSearch("筛选") : this.detailsRequest();
        console.log(`每页 ${val} 条`);
      },
      // 分页 : 换页
      handleCurrentChange(val) {
        this.currpage = val;
        this.filtrate ? this.detailsRequestSearch("筛选") : this.detailsRequest();
        console.log(`当前页: ${val}`);
      },
      handleCheckAllChange(val) {
        //配置表头全选功能
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
        if (!val) {
          this.checkedCities = [
            "序号",
            "业务日期",
            "运单号",
            "产品类型",
            "始发站",
            "目的地",
            "发货人",
            "收货人",
            "货物名称",
            "提货方式",
            "件数",
            "重量",
            "体积",
            "计费重量",
            "总金额",
            "未核销金额",
          ];
        }
      },
      handleCheckedCitiesChange(val) {
        //配置表头单个勾选
        debugger
        let checkedCount = val.length;
        this.checkAll = checkedCount === this.cities.length;
        this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.cities.length;
      },
      titShow() {
        //弹出配置表头
        this.tableShow = !this.tableShow;
      },
      pay(money) {
        // item.payMoney = item;
        this.money = money;
      },
      async confirmPay(item) {
        console.log(1, item);
        item.ConfirmTheBill = false;
        // 请求确认对账单接口
        api.confirmBillList([item.statBillNo]).then((res) => {
          item.status = "confirm";
          console.log(2, item);
          console.log(res);
        });
      },
      // 单个支付，手动确认
      singlePayment(item) {
        console.log("单个账单支付", item);
        if (this.money > item.unRefundAmount) {
          this.money = this.sidebar.totalUnVerifyAmount;
          return this.$message({
            showClose: true,
            message: "支付金额不能大于账单金额",
            type: "error",
            offset: 300,
          });
        }
        if (this.money <= 0) {
          this.money = this.sidebar.totalUnVerifyAmount;
          return this.$message({
            showClose: true,
            message: "输入金额不能小于或等于0",
            type: "error",
            offset: 300,
          });
        }
        var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
        if (!reg.test(this.money)) {
          this.money = this.sidebar.totalUnVerifyAmount;
          return this.$message({
            showClose: true,
            message: "请输入保留两位小数点的正数",
            type: "error",
            offset: 300,
          });
        }
        // 调用支付
        this.detailPayment([item.statBillNo], this.money);
      },
      // 批量支付，自动确认
      detailPayment(statBillNos, money) {
        //支付
        api.createPmcPaymentOrder("" + money, statBillNos).then((payRes) => {
            if(payRes.success){
              this.item.confirmPayment = false;
              window.open(payRes.cashierUrl);
              return;
            }
            this.$message({
              message:payRes,
              type: "error",
              offset: 300,
            });
        });

        // api.createPayOrder("" + money, statBillNos).then((payRes) => {
        //   console.log("支付url: ", payRes);
        //   this.item.confirmPayment = false;
        //   window.open(payRes);
        // });
      },
      // cellHandleclick(row, column, cell, event) {
      //   console.log(row);
      //   console.log(column);
      //   console.log(cell);
      //   console.log(event);
      //   //如果规定点击某一列执行，利用column中的label属性
      //   if (column.label === "某一列名称") {
      //     //执行逻辑
      //   }
      // },
      async selectBy(selectCurList) {
        this.sourceBillNo=selectCurList.sourceBillNo;
        this.orderNo=selectCurList.orderNo;
        this.statBillNo=selectCurList.statBillNo;
        if(selectCurList.billDiffStatus==" 标 记 "){//显示新增框
          this.allMessages[0].statBillNo= this.statBillNo;
          this.allMessages[0].sourceBillNo= this.sourceBillNo;
          this.pullDown=true;
          this.differButton="保 存";
          this.displayStyle=1;
          this.showDiffer=true;
          this.adapt=false;
          this.addNew=true;
          this.selectDiffer=false;
        }else if(selectCurList.billDiffStatus=="已标记"){//显示修改框
          this.selectDifferByNo()
          this.differButton="修 改";
          this.displayStyle=2;
          this.showDiffer=true;
          this.adapt=true;
          this.addNew=false;
          this.selectDiffer=false;
        }else{//显示查询框
          this.selectOverList();
          this.selectDiffer=true;
          this.showDiffer=false;
        }
      },
      closeDialogAddgsVisible() {
        this.clearData();
        this.showDiffer=false;
        //this.$refs.addForm.resetFields();//element封装的方法,清空模态框的值
        this.differTitle = "差异标记" //初始化title的值
        this.addForm = {//初始化addForm中的值
          name: "",
          sort: "",
        }

      },
      async clearData(){//取消或者叉掉后清空文本
        this.remainText=false;
        this.msg.content="";
        this.listOptionId='';

      },
      setPullDown (data) {
        this.pullDown = data
      },
      async remain() {
        this.$message({
          message:this.typeTitle,
          type: this.typeId,//error info warning
        });
      },
      async delDiffer(){//删除
        let parme = {
          "diffBillNo": this.allMessages[0].diffBillNo
        };
        let res = await api.deleteDiffer(parme);
        console.info(res)
        if(res=="删除差异成功"){
          this.typeId="success";
          this.typeTitle="差异标记已删除";
        }else{
          this.typeId="error";
          this.typeTitle="差异标记删除失败";
        }
        this.remain()
        this.closeDialogAddgsVisible()
        this.visible_differ=false
        this.detailsRequest();

      },
      async confirmAdd(){
        let obj = {};//定义对象集合
        obj = this.optionList.find(item => {//projectlist 为Select遍历集合 project 为Select 遍历 对象
          return item.listValue === this.listOptionId; //筛选出匹配数据 返回对象
        });
        if(this.msg.content==""){
          this.msg.content=obj.listName;
        }
        let parme = {
          "statBillNo":this.statBillNo,
          "orderNo":this.orderNo,
          "sourceBillNo":this.sourceBillNo,
          "diffType": this.listOptionId,
          "diffDescription":this.msg.content
        };
        let res = await api.addDiffer(parme);
        console.info(res)

        if(res=="新增差异成功"){
          this.typeId="success";
          this.typeTitle="差异标记成功";
        }else{
          this.typeId="error";
          this.typeTitle="差异标记失败";
        }
        this.remain()
        this.closeDialogAddgsVisible()
        this.detailsRequest();

      },

      async confirmUpdate(){
        let obj = {};//定义对象集合
        obj = this.optionList.find(item => {//projectlist 为Select遍历集合 project 为Select 遍历 对象
          return item.listValue === this.listOptionId; //筛选出匹配数据 返回对象
        });
        // let description='';
        if(this.msg.content=="") {
          this.msg.content = obj.listName;
        }
        let parme = {
          "diffBillNo": this.allMessages[0].diffBillNo,
          "diffType": this.listOptionId,
          "diffDescription": this.msg.content
        }
        let res = await api.updateDiffer(parme);
        console.info(res)
        if (res == "修改差异成功") {
          this.typeId = "success";
          this.typeTitle = "修改差异成功";
        } else {
          this.typeId = "error";
          this.typeTitle = "修改差异失败";
        }
        this.remain()
        this.closeDialogAddgsVisible()
        this.visible_differ1=false;
        this.detailsRequest();
      },

      async isUpdate() {
        let parme = {
          "statBillNo": this.statBillNo,
          "orderNo": this.orderNo,
        };
        let res = await api.selectDifferlist(parme);
        if (this.allMessages[0].diffBillNo == res.diffBillNo && this.listOptionId == res.diffType && this.msg.content == res.diffDescription) {
          this.typeId = "info";
          this.typeTitle = " 请先修改数据再提交！";
          this.remain()
        } else {
          this.confirmUpdate()
        }
      },
      async getPhoneNum(){
        let parme = {
          "diffBillNo": this.selectAllMessages[0].value
        };
        let res = await api.phone(parme);
        if(res==""){
          this.phoneNum="暂未查询到改人员手机号，请联系95353！";
        }else{
          this.phoneNum="联系方式:"+res;
        }
      },


      async selectDifferByNo(){
        let parme = {
          "statBillNo":this.statBillNo,
          "orderNo":this.orderNo,
        };
        let res = await api.selectDifferlist(parme);

        this.listOptionId=res.diffType;
        this.allMessages[0].diffBillNo=res.diffBillNo;
        this.allMessages[0].statBillNo=res.statBillNo;
        this.allMessages[0].sourceBillNo=res.sourceBillNo;
        this.allMessages[0].createUserName=res.createUserName;
        this.msg.content=res.diffDescription;

      },


      async selectOverList(){
        let parme = {
          "statBillNo":this.statBillNo,
          "orderNo":this.orderNo,
        };
        let res = await api.selectDifferlist(parme);
        let obj = {};//定义对象集合
        obj = this.optionList.find(item => {
          return item.listValue === res.diffType;
        });
        this.selectAllMessages[0].value=res.diffBillNo;
        this.selectAllMessages[1].value=res.statBillNo;
        this.selectAllMessages[2].value=res.sourceBillNo;
        this.selectAllMessages[3].value=res.createUserName;
        this.selectAllMessages[4].value=obj.listName;
        this.selectAllMessages[5].value=res.diffDescription;
        this.selectAllMessages[6].value=res.currentHandlerName;
        this.selectAllMessages[7].value=res.finishDescription;
        this.getPhoneNum();
      },

      addOrAdapt(){
        if(this.differButton=="保 存"){
          this.confirmAdd()
        }else if(this.differButton=="修 改"){
          this.isUpdate()
        }
      },

      async saveDiffer(){//新增或者编辑
        if( this.listOptionId!=""){
          this.remainText=false;
          if(this.listOptionId=="other"){
            if(this.msg.content==""){
              this.remainText=true;
              return;
            }else{
              this.addOrAdapt();
            }
          }else{
            this.addOrAdapt();
          }
        }else{
          this.typeId="warning";
          this.typeTitle="请您先选择差异类型，然后再确认！";
          this.remain()
        }
      },
      async detectContentup(){//等检测松开按钮文本框是否为空
        if(this.msg.content==""){
          if(this.listOptionId=="other"){
            this.remainText=true;
          }
        }else{
          this.remainText=false;
        }

      },
      async detectContent(){//检测文本框内容长度

        if(this.msg.content.length==50){
          this.typeId="info";
          this.typeTitle="最大输入50个字符";
          this.remain()
         // this.msg.content =this.msg.content.substr(0, 49)
        }

      },
      selectOption(){//当选择其他的时候，显示提示
        //  event.target.listName;
        if(this.listOptionId=="other"){
          if(this.msg.content==""){
            this.remainText=true;
          }
        }else{
          this.remainText=false;
        }
      },
        //显示账号信息
        async showBankAccount(statBillNo){
          let formData = {
            statementBillNo:statBillNo,
            customerCode: window.localStorage.getItem("customerCode"),
          }
          let res = await api.queryBankInfoByStatNoOrCustomerCode(formData)
          if(res instanceof Object){
            this.confirmPayment = false;
            this.isShowAccountDialog = true
            this.formAccount = res;
          }
        },

        //复制银行账号
        copyAccountInfo(){
        // 点击复制运单号
          let { compBankAccountName, compBankName, compBank } = this.formAccount;
          let str = `${compBankAccountName}-${compBankName}-${compBank}`;
          let oInput = document.createElement("input");
          oInput.value = str;
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand("Copy");
          this.$message({
            message: "账号复制成功,请到银联app转账！请勿转账给个人",
            type: "success",
          });
          oInput.remove();
          this.isShowAccountDialog = false;
        }
    },
    mounted() {
      // DOM渲染后 注册onresize事件 获取动态宽度 , 来解决 BUG(样式问题)
      const _that = this;
      window.onresize = () => {
        return (() => {
          _that.screenWidth = document.body.clientWidth;
        })();
      };
      // setTimeout(() => {
      //   let a = document.querySelectorAll('.el-table__fixed')[0]
      //   // let b = document.querySelectorAll('.el-table__fixed-right')[0]
      //   let table = document.querySelectorAll('.el-table')[0].offsetWidth
      //   let body = document.querySelectorAll('.el-table__body')[0].offsetWidth
      //   console.log('22222222222222',a.style.height);
      //   setTimeout(() => {
      //     if(body>table){
      //       // a.style.height = ((a.style.height.split('px')[0] - 0) - 100 ) + 'px'
      //       // b.style.height= ((b.style.height.split('px')[0] - 0) - 50 ) + 'px'
      //     }
      //   }, 100);
      // }, 1000);
    },
    created() {
       // 设置 默认值为月结信息 Tab
      this.$store.commit("urlIndex", paths('#/'));
      this.checkedCitiesDisable = JSON.parse(JSON.stringify(this.checkedCities)); // 初始化 禁用选项
      this.detail = window.sessionStorage.getItem("detailBill")
      if(this.detail == null){
        this.detail = window.localStorage.getItem("detailBill")
      }
      this.item = JSON.parse(this.detail);
      // console.log(this.item,'22222');
      // window.sessionStorage.removeItem()
      this.item.billEnd = this.$moment(this.item.billEnd).format("YYYY-MM-DD");
      this.item.billStar = this.$moment(this.item.billStar).format("YYYY-MM-DD");
      // console.log(22222, this.item);
      this.detailsRequest();
    },
  };
</script>

<style lang='less' scoped>
.periods {
  display: flex;
  height: 100%;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  background-color: #f7f7f8ff;
  font-size: 14px;
  .track-series {
    padding-top: 8px;
    .track {
      font-size: 16px;
      display: flex;
      font-weight: 400;
      color: #09090A;
      .express-state {
        text-align: right;
        width: 139px;
        padding: 16px 56px 16px 10px;
      }
      .circle {
        background-color: transparent;
        position: relative;
        .first {
            color: #fff;
            width: 48px;
            height: 48px;
            z-index: 2;
            background-image: url("../../../assets/picture/expressage.png");
            background-size:48px 48px;
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
      }
      .circle span {
        position: absolute;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #E5E6E6;
        top: 18px;
        left: -8px;
        // transform: translate(-50%, -50%);
        z-index: 1;
      }
      .circle .center {
        width: 2px;
        height: 100%;
        background: #E5E6E6;
      }
      .detail {
        flex: 1;
        padding: 16px 56px;
      }
  }
   .track:first-child .express-state{
        font-size: 20px;
        font-weight: 400;
        color: #003C8D;
   }
  .track:first-child .circle .center,
  .track:last-child .circle .center {
     position: absolute;
     left: 0;
     width: 2px;
     height: 55%;
     background: #E5E6E6;
   }
  .track:last-child .circle .center {
    top: 0;
     height: 13%;
   }
  //  .track:last-child .circle .center {
  //    top: 0;
  //  }
   .track:first-child .circle .center {
     bottom: 0px;
   }
   .track:last-child .circle .first {
     width: 48px;
     height: 48px;
     z-index: 2;
     position: absolute;
     top: 30%;
     left: 50%;
     transform: translate(-50%, -50%);
     background-image: url("../../../assets/picture/Fedex-started.png");
     background-size:48px 48px;
   }
  }

  /deep/.el-drawer__open .el-drawer.rtl{
    width: 640px !important;
    height: 100% !important;
    background: #fff !important;
  }
  .The-waybill-details {
    width: 640px;
    width: 100%;
    height: 100%;
    text-align: left;
    .The-waybill-details-title {
      height: 56px;
      line-height: 55px;
      border: 1px solid #EFF0F0;
      padding-left: 16px;
      position: relative;
      .close {
        position: absolute;
        bottom: 17px;
        right: 28px;
        font-size: 20px;
        color: #AFB1B7;
      }
      .flex1 {
        display: flex;
        .tabs {
          width: 60px;
          height: 55px;
          margin-right: 30px;
          &:hover {
            color: #008cffff;
          }
        }
      }
      .tabBorder {
        color: #000;
        border-bottom: 2px solid #008cffff;
      }
    }
    .details-box {
       padding: 0 24px;
      .details-box-t {
        width: 100%;
        height: 104px;
        justify-content: space-between;
        border-bottom: 1px solid #EFF0F0;
        position: relative;
        padding-left: 8px;
        font-size: 17px;
        font-weight: 600;
        color: #2F3031;
        line-height: 26px;
        padding-top: 24px;
        .top11{
          padding-top: 11px;
        }
        .waybill-number {
          display:-webkit-box;
          width: 164px;
          height: 74px;
          font-size: 30px;
          font-family: FZLTCHJW--GB1-0, FZLTCHJW--GB1;
          font-weight: normal;
          color: #1A1A1A;
          line-height: 37px;
        }
        .waybill-type-box {
          position: absolute;
          bottom: 18px;
          left: 164px;
          background: #E4ECFB;
          border-radius: 12px;
          .waybill-type {
            padding: 2px 8px;
            font-size: 14px;
            font-weight: 600;
            color: #5186D2;
            line-height: 20px;
          }
        }
      }
      .details-box-address {
        height: 123px;
        border-bottom: 1px solid #EFF0F0;
        padding-top: 14px;
        font-size: 16px;
        font-weight: 500;
        color: #09090A;
        .details-address {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(47, 48, 49, 0.5);
          line-height: 18px;
        }
      }
      .cargo-information-box{
        height: 330px;
        .cargo-information {
          height: 50px;
          border-bottom: 1px solid #EFF0F0;
          div{
            width: 196px;
            line-height: 50px;
            padding-left: 16px;
            font-size: 14px;
            font-weight: 400;
            color: #09090A;
          }
          :first-child{
            padding-left: 0px;
          }
          .cargo-information2 {
            height: 50px;
            border-left: 1px solid #EFF0F0;
            border-right: 1px solid #EFF0F0;
          }
        }
      }
      .function-box {
        .function-btn{
          padding-left: 24px;
          img {
            height: 25px;
          }
          div {
          font-size: 14px;
          color: #09090A;
          line-height: 28px;
          padding-left: 4px;
          }
        }
      }
    }
  }
  .cut-off-rule {
    margin: 11px 20px;
    background-color: rgba(0, 0, 0, 0.06);
    width: 1px;
    height: 9px;
  }
  .Email-error {
    font-size: 13px;
    color: #f56c6c;
    text-align: left;
    padding-left: 70px;
    margin-top: 5px;
  }
  .top {
    margin-top: 10px;
  }
  .strong-frame {
    .row {
      display: flex;
      div {
        width: 68px;
        height: 68px;
        background: #f2f2f2;
        margin-right: 32px;
      }
      .divpitch-on {
        background: #d4ebff;
        border-radius: 3px;
        border: 1px solid #008cff;
      }
      .excel {
        margin-top: 16px;
        width: 40px;
        height: 36px;
      }
      .pdf {
        margin-top: 13px;
        width: 35px;
        height: 42px;
      }
    }
  }
  .breadcrumb {
    text-align: left;
    height: 44px;
    margin-bottom: 5px;
    background: #fff;
    border: 1px solid #ececec;
    padding: 6px 24px;
    font-size: 14px;
    .TitBtn {
      display: inline-block;
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #afb1b7;
      padding-right: 10px;
      color: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      margin-right: 20px;
    }
    .tipName {
      color: rgba(0, 0, 0, 0.4);
      .currentTip {
        color: #000000cc;
      }
    }
  }
  .cen {
    padding: 24px;
    width: 100%;
    height: 100%;
    display: flex;
    overflow: auto;
  }
  .leftTip {
    width: 245px;
    height: 524px;
    margin-right: 6px;
    padding: 24px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 245px 524px;
    text-align: left;
    position: relative;
    .closed-account-img {
      position: absolute;
      top: 20px;
      right: 0;
    }
    .text {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.4);
      line-height: 20px;
    }
    .num {
      span:nth-child(1) {
        font-size: 35px;
        font-weight: 500;
        line-height: 40px;
      }
      span:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
      }
    }
    .color {
      color: rgb(136, 133, 133);
    }
    .line {
      margin: 16px 0;
      border-top: 1px solid #00000014;
    }
    .text2 {
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin: 4px 0 16px;
      cursor: pointer;
    }
    .downloadBill {
      cursor: pointer;
      margin: 20px 0;
      display: flex;
      // width: 100%;
      text-align: center;
      color: #008cff;
      .confirm {
        flex: 1;
        padding-right: 12px;
      }
      .gap {
        height: 22px;
        margin-right: 24px;
        border-left: 1px solid #00000014;
      }
      .download {
        flex: 1;
      }
    }
    .pay {
      text-align: center;
      height: 32px;
      background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
      box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
      border-radius: 4px;
      line-height: 32px;
      color: #ffffff;
      cursor: pointer;
    }
    .NOpay {
      text-align: center;
      height: 32px;
      background: #fff;
      color: rgba(0, 140, 255, 0.24);
      border-radius: 4px;
      line-height: 32px;
      cursor: pointer;
      border: 1px solid rgba(0, 140, 255, 0.24);
    }
    .colorrgb {
      color: rgba(0, 140, 255, 0.24);
    }
  }
  .leftTipBackground-image {
    background-image: url("../../../assets/bg.png");
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
      padding: 32px 24px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      .flex1 {
        // overflow: hidden;
        text-align: left;
        display: flex;
        align-items: center;
        color: #323233;
        width: 328px;
        position: relative;
      }
      .showcase {
        width: 328px;
      }
      .mainTop {
        .batchInput {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          /deep/.el-textarea textarea {
            padding-bottom: 50px;
          }
        }
        .batchSearch {
          z-index: 1111;
          position: absolute;
          bottom: 1px;
          right: 15px;
          text-align: right;
          width: 300px;
          background-color: #fff;
          padding: 5px 5px 15px 5px;
          .searchBtn {
            border: 1px solid #008cff;
            padding: 3px 12px;
            border-radius: 5px;
            color: #008cff;
            cursor: pointer;
            font-weight: 500;
            &:hover {
              background-color: #008cff;
              color: #fff;
            }
          }
        }
        /deep/.el-textarea {
          z-index: 99;
          textarea {
            max-height: 450px;
          }
        }
      }
      .seldate {
        margin: 0 15px;
        .el-input__inner {
          flex: 1;
        }
        .el-input__inner {
          width: 100%;
        }
        .el-date-editor/deep/.el-range-separator {
          width: 16px;
          padding: 0;
        }
      }
      .selects {
        padding: 0 10px;
        .el-select {
          flex: 1;
        }
      }
      .btn {
        font-size: 14px;
        align-items: center;
        .b1 {
          margin-right: 15px;
          cursor: pointer;
          font-weight: 500;
          color: #008cff;
          line-height: 20px;
          &:hover {
            color: #008cffa6;
          }
        }
        .b2 {
          width: 60px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
          box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
          border-radius: 4px;
        }
      }
    }
    .main {
      height: 100%;
      padding: 24px 0 0 0px;
      display: flex;
      flex-direction: column;
      margin-top: 5px;
      background-color: #fff;
      border-radius: 4px;
      overflow: auto;
      .tableTiele {
        padding-left: 24px;
        font-size: 14px;
        font-weight: 600;
        color: #008cff;
        text-align: left;
        position: relative;
        .setup {
          cursor: pointer;
          display: inline-block;
          &:hover {
            color: #008cffaa;
          }
        }
        .titName {
          height: 242px;
          width: 234px;
          border-radius: 4px;
          border: 1px solid #ccc;
          position: absolute;
          top: 26px;
          left: 24px;
          z-index: 1011;
          background-color: #fff;
          padding: 8px;
          overflow: auto;
          .el-checkbox-group {
            overflow: auto;
          }
          .el-checkbox {
            width: 100%;
            margin: 4px 0;
          }
        }
      }
      .tables {
        height: 100%;
        margin-top: 22px;
        padding-left: 24px;
        overflow: hidden;
        flex: 1;
        overflow: auto;
        min-width: 900px;
        /deep/.el-table {
          .el-table__fixed,
          .el-table__fixed-right {
            top: 0px;
            height: calc(100% - 20px) !important;
            background-color: #fff;
          }
          .el-table__fixed{
          }
          .el-table__fixed-body-wrapper {
            top: 48px !important;
            // height: calc(100% - 65px) !important;
            height: calc(100% - 70px) !important;
          }
          .el-table__body-wrapper {
            // height: calc(100% - 50px) !important;
            height: calc(100% - 60px) !important;
          }
        }
      }
      .bottom {
        height: 32px;
        margin: 3px 0 10px 0;
      }
    }
  }
  .bottom {
    padding-left: 20px;
    text-align: left;
  }
  /deep/.el-table__fixed-right-patch {
    height: 49px !important;
  }
}
  .el-select{
    width: 80%;
  }
  .el-dialog li{
    list-style: none;
  }
  #numList li,#selectNumList li{display: flex;flex-direction: row;width: 100%;margin-bottom:24px;}
  #selectNumList .differTitle{width: 100px;text-align: left}
  #numList{    margin-bottom: 20px;}
  #numList,#selectNumList{    width: 100%;}
  #numList .differValue{width: 80%;text-align: left;padding-left: 30px;}
  .differTitle{width:  61px;    text-align: right;}

  .blue{color:#008cff}
  .black{color: #645556}
  #addDisplay{display: flex;justify-content: flex-end}
  #delDisplay{display: flex;justify-content: space-between}
  #isDel{border: none;color: red;background: white}
  #isDel:hover{color: red;background: white}
  #delDisplay ，addDisplay .el-button{margin-right: 12px}
  .e_account{
   div{
    text-align: left;
    margin-bottom: 10px;
    label{
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-left:30px;
    }
  }
  }
</style>